/* Titan Tarps — reveal-on-scroll and small motion helpers.
   - Content already on screen at load shows immediately (no hidden hero,
     no LCP delay); only content below the fold fades in, once.
   - Product gallery: warm images on hover/touch, crossfade on swap.
   Reduced motion is handled in CSS. */
(function () {
  window.__ttReveal = true;
  var els = document.querySelectorAll('.tt-reveal');

  if (els.length) {
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });

      els.forEach(function (el) {
        if (el.getBoundingClientRect().top < vh) {
          el.classList.add('tt-instant', 'is-visible');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { el.classList.remove('tt-instant'); });
          });
        } else {
          io.observe(el);
        }
      });
    }
  }

  /* Gallery: warm the full-size image on hover/touch so the swap is instant */
  var warmed = {};
  var warm = function (e) {
    var btn = e.target.closest && e.target.closest('.tt-pd__thumb');
    if (!btn || warmed[btn.dataset.src]) return;
    warmed[btn.dataset.src] = true;
    var img = new Image(); img.src = btn.dataset.src;
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });

  /* Gallery crossfade: runs after the section's own click handler swaps src */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.tt-pd__thumb');
    if (!btn) return;
    var gallery = btn.closest('.tt-pd__gallery');
    var main = gallery && gallery.querySelector('[data-tt-main] img');
    if (!main || !main.animate) return;
    var run = function () {
      main.animate(
        reduce
          ? [{ opacity: 0.4 }, { opacity: 1 }]
          : [{ opacity: 0.4, filter: 'blur(2px)' }, { opacity: 1, filter: 'blur(0px)' }],
        { duration: 220, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
      );
    };
    if (main.decode) { main.decode().then(run, run); } else { run(); }
  });
})();